import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useLocale } from '../context/LocaleContext';
import { CarCard } from './CarCard';
import { useIntersectionReveal } from '../hooks/useIntersectionReveal';
import { getVehicles } from "../apis/vehicles";
export const InventorySection = () => {
    const { t } = useLocale();
    const ref = useIntersectionReveal();
    const [cars, setCars] = React.useState([]);
    React.useEffect(() => {
        getVehicles().then(res => {
            setCars(res.data);
        }).catch((res) => {
            console.error('Failed to fetch vehicles:', res);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs("section", { id: "inventory", ref: ref, className: "inventory-section", children: [_jsx("div", { className: "section-head", children: _jsx("h2", { children: t('cars.title') }) }), _jsx("div", { className: "car-grid", children: cars.map(car => (_jsx(CarCard, { car: car }, car.id))) })] }));
};
